// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-overlay {
  position: absolute;
  background-color: black;
  opacity: 0.5;
  height: 100%;
  width: 100%;
}

.contact-form-container {
  background-color: white;
  position: relative;
  flex-direction: column;
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/white-crack.jpeg");
  background-size: cover;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-form {
  width: 600px;
  background-color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.subm-btn {
  margin: auto;
  text-decoration: none;
  padding: 1em;
  width: 10em;
}

input[type=text],
input[type=password],
input[type=date],
input[type=datetime],
input[type=email],
input[type=number],
input[type=search],
input[type=tel],
input[type=time],
input[type=url],
textarea,
select {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: lightgray;
  color: #551fbd;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
  font-family: "Spartan", sans-serif;
}

label {
  padding: 15px;
  font-family: "Spartan", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/Contact/Styles.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEE;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yFAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEE;;;;;;;;;;;;EAYE,oCAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,6CAAA;EACA,mBAAA;EACA,kCAAA;AACJ;;AAEE;EACE,aAAA;EACA,kCAAA;AACJ","sourcesContent":[".contact-overlay {\n    position: absolute;\n    background-color: black;\n    opacity: 0.5;\n    height: 100%;\n    width: 100%;\n  }\n  \n  .contact-form-container {\n    background-color: white;\n    position: relative;\n    flex-direction: column;\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/white-crack.jpeg\");\n    background-size: cover;\n    background-attachment: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .contact-form {\n    width: 600px;\n    background-color: white;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .subm-btn {\n    margin: auto;\n    text-decoration: none;\n    padding: 1em;\n    width: 10em;\n  }\n  \n  input[type=\"text\"],\n  input[type=\"password\"],\n  input[type=\"date\"],\n  input[type=\"datetime\"],\n  input[type=\"email\"],\n  input[type=\"number\"],\n  input[type=\"search\"],\n  input[type=\"tel\"],\n  input[type=\"time\"],\n  input[type=\"url\"],\n  textarea,\n  select {\n    background: rgba(255, 255, 255, 0.1);\n    border: none;\n    font-size: 16px;\n    height: auto;\n    margin: 0;\n    outline: 0;\n    padding: 15px;\n    width: 100%;\n    background-color: lightgray;\n    color: #551fbd;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;\n    margin-bottom: 30px;\n    font-family: \"Spartan\", sans-serif;\n  }\n  \n  label {\n    padding: 15px;\n    font-family: \"Spartan\", sans-serif;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
